import React from 'react'
import { connect } from 'react-redux'
import styled, { keyframes } from 'styled-components'
import { FaSpinner } from 'react-icons/fa'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 120px;
    height: 120px;
    animation: ${rotate} 2s linear infinite;
    color: ${props => props.theme.colors.alternativeHover};
  }
`

const SavingBackground = ({ isSaving = false }) => (
  <Background style={{ display: isSaving ? 'flex' : 'none' }}>
    <FaSpinner />
  </Background>
)

export default connect(state => ({
  isSaving: state.project.isSaving,
}))(SavingBackground)



// WEBPACK FOOTER //
// ./src/components/SavingBackground/index.js